function cleanObject(obj, keysSource) {
  let filteredEntries = Object.entries(obj).filter(([_, value]) => value !== null && value !== void 0);
  if (keysSource) {
    const keysToRemove = Object.keys(keysSource);
    filteredEntries = filteredEntries.filter(([key]) => !keysToRemove.includes(key));
  }
  return Object.fromEntries(filteredEntries);
}
export {
  cleanObject
};
